import { render, staticRenderFns } from "./CustomerAddressNewPopup.vue?vue&type=template&id=cda5a72a&"
import script from "./CustomerAddressNewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports